









































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import CurrentTime from '@/models/current-time/CurrentTime'
import { create as createCurrentTime } from '@/models/current-time/functions'

import { Fku } from './model/item'
import { ApparelAddToCartSelectionState } from './selection-state'
import { SkuStatusLabelUiText } from './ui-text/sku-status-label'

@Component
export default class ColorSelection extends Vue {
  @Prop({ required: true })
  state: ApparelAddToCartSelectionState

  @Prop({ required: true })
  instanceId: string

  @Prop({ default: () => createCurrentTime() })
  current: CurrentTime

  @Prop({ required: true })
  skuStatusLabelText: SkuStatusLabelUiText

  get fkuList(): Fku[] {
    return this.state.fkuList
  }

  get colorInputName(): string {
    return `apparel-add-to-cart-color-${this.instanceId}`
  }

  isSelectedFku(fkuId: string): boolean {
    return this.state.selectedFku.map(f => f.id).toNullable() === fkuId
  }

  get selectedColorLabel(): string {
    return this.state.selectedFku.map(f => f.colorLabel).getOrElse('-')
  }

  // セール中のSKUが存在するFKUにSaleと出す
  // カラーを選んで初めてセール商品があると分かるのでなく、
  // このカラーにはセール中のサイズがあるよ！と目立たせて選択してもらう狙い
  saleLabelFor(fku: Fku): string | null {
    if (fku.hasDiscountSaleSku) {
      return 'Sale'
    }

    return null
  }

  get showStatusLabel(): boolean {
    return this.fkuList.some(f => this.hasStatusLabelFor(f))
  }

  statusLabelFor(fku: Fku): string | null {
    return this.unavailableLabelFor(fku) || this.lowStockLabelFor(fku)
  }

  hasStatusLabelFor(fku: Fku): boolean {
    return !!this.statusLabelFor(fku)
  }

  /**
   * 以下の場合はカラーを選択してもユーザーが取れるアクションがないので、カラーに商品の状態を併記する
   * - 紐づく全てのSKUが入荷待ちのとき
   * - 紐づく全てのSKUが在庫切れのとき
   */
  unavailableLabelFor(fku: Fku): string | null {
    const salesStatuses = fku.skuList.map(sku => sku.resolveSalesStatus(this.current.now))

    if (salesStatuses.every(type => type === 'coming-soon')) {
      return this.skuStatusLabelText.comingSoon
    }

    if (salesStatuses.every(type => type === 'sold-out')) {
      return this.skuStatusLabelText.soldOut
    }

    return null
  }

  /**
   * 紐づくSKUが1種類のみで、そのSKUが在庫が少ない場合はカラーに煽り表示を併記する
   */
  lowStockLabelFor(fku: Fku): string | null {
    if (fku.skuList.length === 1) {
      const sku = fku.skuList[0]

      if (sku.resolveSalesStatus(this.current.now) === 'standard-order') {
        return sku.stockText || null
      }
    }

    return null
  }

  colorInputId(fkuId: string): string {
    return `${this.colorInputName}-${fkuId}`
  }

  onChange(fku: Fku) {
    if (this.isSelectedFku(fku.id)) {
      return
    }

    this.$emit('select-fku', fku)
  }
}
